import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminSearchResultView = lazy(() => import("@/pages/admin/AdminSearchResultView"));

export const Route = createFileRoute("/admin/sokresultat")({
  component: () => <AdminSearchResultView />,
});
